import { render, staticRenderFns } from "./addRedirect.vue?vue&type=template&id=5d061d23&"
import script from "./addRedirect.vue?vue&type=script&lang=js&"
export * from "./addRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports